export default __webpack_public_path__ + "static/media/snd_00007.4a46cd2c.mp4";